import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idUser: number;
  idDebit: number;
};

export const getReport = async (params: Params): Promise<Blob> => {
  const response = await customFetch(
    getM8AdminURL(`getReport?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.blob();
};
